import React from "react";
import PageShell from "../components/common/PageShell";
import SectionTwoHomePage from "../components/home/SectionTwoHomePage";
import SectionThreeHomPage from "../components/home/SectionThreeHomPage";
import SectionFourHomePage from "../components/home/SectionFourHomePage";
import ImageSlider from "../components/home/ImageSlider";

function HomePage() {
  return (
    <PageShell>
      <div className="min-h-0 bg-[var(--caf-surface)]">
        <ImageSlider />
        <SectionTwoHomePage />
        <SectionThreeHomPage />
        <SectionFourHomePage />
      </div>
    </PageShell>
  );
}

export default HomePage;
